/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const manageLoopEstimationSchemeAssignmentsRequestSchema = z.object({
  estimationSchemeIds: z.array(z.int()),
});
